// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1ProjectSchema } from './v1/projectSchema';

export const listProjectsPathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID for the clients you want to retrieve"),
});

export const listProjectsQueryParamsSchema = z.object({
  offset: z.optional(z.number().int().describe("Retrieve projects from offset")),
  limit: z.optional(z.number().int().describe("Retrieve number of projects")),
  order: z.optional(z.coerce.string().describe("Sorting order - desc, asc (Default desc)")),
  filter: z.optional(z.enum(["mine", "active", "all", "archived"]).describe("Deprecated: Filter projects - mine, active, archived, all (Default mine, ignored if state or relation parameter present)")),
  state: z.optional(z.enum(["all", "active", "archived"]).describe("Filter projects - active, archived, all")),
  relation: z.optional(z.enum(["all", "assigned", "created"]).describe("Filter projects - assigned, created, all")),
  updated_after: z.optional(z.coerce.string().describe("Retrieve records updated after a certain timestamp")),
  project_ids: z.optional(z.array(z.number()).describe("Retrieve specific projects")),
  external_ids: z.optional(z.array(z.number()).describe("Retrieve specific projects by external ID reference")),
}).optional();

export const listProjectsHeaderParamsSchema = z.object({
  Authorization: z.coerce.string(),
});

/**
 * @description Project Details
 */
export const listProjects200Schema = z.array(z.lazy(() => v1ProjectSchema));

export const listProjectsQueryResponseSchema = z.lazy(() => listProjects200Schema);
